import { useState } from "react";
import { TextInput, Select, NumberInput, Button, Box } from "@mantine/core";
import { UNIT_TYPES } from "../utils/constants";
import classes from "../styles/unit-modal.module.css";

export default function UnitModal({ onSave }) {
  const [formData, setFormData] = useState({
    id: "",
    area: 0,
    type: UNIT_TYPES.STANDARD.value,
  });

  const selectData = Object.values(UNIT_TYPES).map((t) => ({
    value: t.value,
    label: t.label,
  }));

  const handleSubmit = () => {
    onSave(formData);
  };

  return (
    <Box className={classes["form-container"]}>
      <TextInput
        label="Mã căn hộ"
        placeholder="VD: 101"
        className={classes["modal-input"]}
        classNames={{ input: "mono" }}
        value={formData.id}
        onChange={(e) => setFormData({ ...formData, id: e.target.value })}
      />

      <NumberInput
        label="Diện tích (m²)"
        className={classes["modal-input"]}
        classNames={{ input: "mono" }}
        value={formData.area}
        onChange={(val) => setFormData({ ...formData, area: val || 0 })}
        min={0}
        decimalScale={1}
      />

      <Select
        label="Loại căn hộ"
        className={classes["modal-input"]}
        value={formData.type}
        onChange={(val) => setFormData({ ...formData, type: val || "" })}
        data={selectData}
        comboboxProps={{
          zIndex: 2000,
          withinPortal: true,
          transitionProps: { transition: "pop", duration: 200 },
        }}
      />

      <Button
        fullWidth
        onClick={handleSubmit}
        className={classes["submit-button"]}
      >
        Tạo căn hộ
      </Button>
    </Box>
  );
}
